import { render, staticRenderFns } from "./LanguagesTranslationsForms.vue?vue&type=template&id=08c8aaec&scoped=true&"
import script from "./LanguagesTranslationsForms.vue?vue&type=script&lang=js&"
export * from "./LanguagesTranslationsForms.vue?vue&type=script&lang=js&"
import style0 from "./LanguagesTranslationsForms.vue?vue&type=style&index=0&id=08c8aaec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c8aaec",
  null
  
)

export default component.exports